module.exports = __webpack_public_path__ + "img/dps.01789179.jpg";